export default __webpack_public_path__ + "static/media/about_detail_icon.2ee9c63c.svg";